// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { MyProvider } from './context/MyContext';
import { Provider } from 'react-redux';
import { store } from './store';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MyProvider>
        <App />
      </MyProvider>
    </Provider>
  </React.StrictMode>
);
